import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const calendarManagement = createApi({
    reducerPath: "calendarManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        calendarList: builder.mutation({
            query: ({dateFrom, dateTo}) => {
                let url = `v1/${locale}/calendar/date-range/${dateFrom}/${dateTo}`;

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
    }),
});

export const { useCalendarListMutation } = calendarManagement;
